import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterEvent, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-feature-modal',
  templateUrl: './feature-modal.component.html',
  styleUrls: ['./feature-modal.component.css'],
})
export class FeatureModalComponent implements OnInit, OnDestroy {
  @Input() body: Observable<string>;
  @Input() image: string;
  @Input() intro: Observable<string>;
  @Input() orgId: string;
  // @Input() router: Router;
  @Input() showCTA = true;
  @Input() showClose = true;
  @Input() title: Observable<string>;
  @Input() type: string;
  private ctaClicked = false;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // Load defaults based on type if value not provided
    this.image = this.image || `getapollo.io-fm-${this.type}.svg`;
    this.title =
      this.title || this.translate.get(`feature-modal.${this.type}.title`);
    this.intro =
      this.intro || this.translate.get(`feature-modal.${this.type}.text.intro`);
    this.body =
      this.body || this.translate.get(`feature-modal.${this.type}.text.body`);

    this.router.events
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((event: RouterEvent) => {
        if (event instanceof NavigationStart) {
          if (this.ctaClicked) {
            this.activeModal.close();
          } else {
            this.activeModal.dismiss();
          }
        }
      });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onOpenPlanList() {
    this.ctaClicked = true;
    this.router.navigate([this.orgId, 'subscriptions', 'plans']);
  }
}
